// src/services/nps.service.js
import authService from './auth.service';

class NPSService {
    async getCompanyBySlug(slug, shouldIncrement = true, branchId = null) {
        const url = branchId 
            ? `/s/${encodeURIComponent(slug)}/${encodeURIComponent(branchId)}`
            : `/s/${encodeURIComponent(slug)}`;
    
        return authService.makeRequest({
            method: 'GET',
            url: url,
            headers: {
                'X-Increment-Counter': shouldIncrement.toString()
            }
        });
    }
    
    async getCompanyByCustomLink(customLink, shouldIncrement = true, branchId = null) {
        const url = branchId 
            ? `/c/${encodeURIComponent(customLink)}/${encodeURIComponent(branchId)}`
            : `/c/${encodeURIComponent(customLink)}`;
    

        // console.log ("url dentro de nps.service getCopanyByCustomLink", url);
        return authService.makeRequest({
            method: 'GET',
            url: url,
            headers: {
                'X-Increment-Counter': shouldIncrement.toString()
            }
        });
    }

    async submitReview(reviewData) {
        return authService.makeRequest({
            method: 'POST',
            url: '/reviews',
            data: reviewData
        });
    }

    async updateReview(reviewId, reviewData) {
        return authService.makeRequest({
            method: 'PUT',
            url: `/reviews/update/${reviewId}`,
            data: reviewData
        });
    }


    async getRedirectLink(nps, companyId, branchId = 0) {
        return authService.makeRequest({
            method: 'GET',
            url: '/links',
            params: {
                nps,
                id_company: companyId,
                id_branch: branchId
            }
        });
    }
}

export default new NPSService();